import classNames from 'classnames';
import React from 'react';
import type { StudyFilterSectionVariant } from '../StudyFilterSection/StudyFilterSectionVariant';
import type { EducationSearchItem } from '~/Features/Search/Education/Service/EducationSearchItem.csharp';
import type { SearchResultResponse } from '~/Features/Search/SearchResultResponse.csharp';
import { mapToStudyCardProps } from '~/Pages/StudyListPage/StudyListSearch/studyListSearchUtils';
import type { LinkCardVariant } from '~/Partials/LinkCard/LinkCardVariant.csharp';
import type { PagedFetchDataProps } from '~/Partials/PagedFetchData/PagedFetchData';
import { PagedFetchData } from '~/Partials/PagedFetchData/PagedFetchData';
import type { QueryParameter } from '~/Partials/SearchBase/QueryParameterUtils';
import { StudyCard } from '~/Partials/StudyCard/StudyCard';
import styles from './StudyFilterResults.module.css';

export interface StudyFilterResultsProps {
    baseUrl: string;
    searchParams: QueryParameter[];
    translations: PagedFetchDataProps<EducationSearchItem>['translations'];
    variant: StudyFilterSectionVariant;
    studyCardVariant: LinkCardVariant;
    initialResult?: SearchResultResponse<EducationSearchItem>;
}

export const StudyFilterResults: React.FC<React.PropsWithChildren<StudyFilterResultsProps>> = props => {
    const { baseUrl, searchParams, translations, initialResult, variant, studyCardVariant } = props;
    const studyFilterResultsVariant = variant === 'light' ? 'dark' : 'light';

    return (
        <div className={classNames(styles.StudyFilterResults, styles[`Variant--${studyFilterResultsVariant}`])}>
            <PagedFetchData<SearchResultResponse<EducationSearchItem>, EducationSearchItem>
                baseUrl={baseUrl}
                searchParams={searchParams}
                debounceTime={200}
                take={6}
                translations={translations}
                autoRun={!initialResult}
                initialData={initialResult}
                listClassName={styles.List}
            >
                {results => (
                    <StudyCard
                        {...mapToStudyCardProps(results.data)}
                        variant={studyCardVariant}
                        className={styles.StudyCard}
                    />
                )}
            </PagedFetchData>
        </div>
    );
};
